<template>
  <div v-if="isOpen" class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex justify-center items-center">
    <div class="bg-white p-5 rounded-lg shadow-lg">
      <h2 class="text-lg font-bold mb-4">Select Next Step</h2>
      <div class="space-y-3">
        <input
          type="date"
          v-model="selectedDate"
          class="w-full rounded border p-2 text-sm"
        >
        <div class="grid grid-cols-2 gap-2">
          <input
            type="time"
            v-model="selectedTime"
            class="w-full rounded border p-2 text-sm"
          >
          <select v-model="selectedStatus" class="w-full rounded border p-2 text-sm">
            <option value="">Select status</option>
            <option v-for="status in interviewStatuses" :key="status" :value="status">
              {{ status }}
            </option>
          </select>
        </div>
        <textarea
          v-model="stepNote"
          rows="3"
          placeholder="Step note (optional)"
          class="w-full rounded border p-2 text-sm"
        ></textarea>
      </div>
      <div class="flex justify-end space-x-2 pt-2">
        <button @click="close" class="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400">Cancel</button>
        <button
          @click="confirmSelection"
          :disabled="!selectedStatus"
          class="px-4 py-2 bg-brand-600 text-white rounded hover:bg-brand-700 disabled:cursor-not-allowed disabled:bg-gray-300"
        >
          Confirm
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { toLocalDateInputValue } from '@/utils/date';

export default {
  props: {
    isOpen: Boolean,
    statuses: Array,
  },
  data() {
    return {
      selectedDate: '' as string,
      selectedTime: '' as string,
      selectedStatus: '' as string,
      stepNote: '' as string,
    };
  },
  computed: {
    interviewStatuses(): string[] {
      return ((this.statuses as string[]) || []).filter((status) => status !== 'Applied');
    },
  },
  watch: {
    isOpen(open: boolean): void {
      if (open) {
        this.selectedDate = toLocalDateInputValue();
        this.selectedTime = '';
        this.selectedStatus = '';
        this.stepNote = '';
      }
    },
  },
  methods: {
    close(): void {
      this.$emit('close');
    },
    confirmSelection(): void {
      if (!this.selectedStatus) return;
      this.$emit('dateSelected', this.selectedDate, this.selectedStatus, this.selectedTime, this.stepNote);
      this.close();
    },
  },
};
</script>
